/**
 * VisitorSeam — the end of a visitor's wall (`Wall`'s `footer`), in the page's own flow at its natural height: a fade
 * over the blurred coda above it, the panel (muse choice and the sign-in card), then the proof page's body for a visitor
 * without its muse section. The proof's closing keeps its words and opens the visitor sign-in layer instead of
 * navigating. The proof is `@core/proof`'s own component, given Ovid's data. The site footer follows at route level.
 */
import {ProofSections} from '@core/proof/ProofPage'
import {ovidProofParts} from '@product/ovid/proof/OwnMuseBuilding'
import {VisitorPanel, type VisitorPanelProps} from './VisitorPanel'
import type {SeamProof} from './seamProof'
import styles from './VisitorSeam.module.scss'

export type VisitorSeamProps = VisitorPanelProps & {
    /** Null when the page could not read the proof: the seam is then the panel alone. */
    proof: SeamProof | null
    /** Opens the visitor sign-in layer. */
    onSignIn: () => void
}

export function VisitorSeam({proof, onSignIn, ...panel}: VisitorSeamProps) {
    return (
        <div className={styles.seam}>
            <div className={styles.fade} aria-hidden="true" />
            <VisitorPanel {...panel} />
            {proof && <ProofSections data={proof} parts={ovidProofParts} onClosing={onSignIn} />}
        </div>
    )
}
